module.exports = __webpack_public_path__ + "static/media/onelogo.d2fc4550.svg";